import React, { useEffect, useState } from "react";
import Image from "react-bootstrap/Image"
import QRCode from "qrcode";

export default function QRCodeGenerate({ eventUrl, hashKey }) {
    const [qrCodeUrl, setQrCodeUrl] = useState("");

    useEffect(() => {
        // Construct the URL with the nftValue
        const url = `${eventUrl}?nft=${hashKey}`;
    
        // Generate the QR code and set it as an image URL
        QRCode.toDataURL(url, { width: 160, errorCorrectionLevel: 'H' })
          .then(setQrCodeUrl)
          .catch(err => {});
    }, [hashKey]);

    return (
        <div className="qrCodeContainer">
            {qrCodeUrl ?
                <Image 
                    loading="lazy"
                    src={qrCodeUrl}
                    width="160px"
                    height="160px"
                    alt="QR Code"
                />
            : "Loading QR code..."}
        </div>
    );
}
